module.exports = __webpack_public_path__ + "img/infibo-trades-screenshot-en.1b1a4c50.png";